import React from 'react'
import styles from "./SectionRestaurant.module.css"

const SectionCacao = () => {
  return (
    <section className={styles.section}>
        <div className={styles.container}>
                <div className={styles.imageContainer}>
                    <img src="/images/gastronomia.jpg" alt="gastronomia" />
                </div>
            <div className={styles.textContainer}>
                <h1>Restaurante</h1>
                <p>El Hotel Torre Eiffel Atacames no solo ofrece una vista privilegiada del Pacífico, sino también un viaje gastronómico a través de los sabores más auténticos de Esmeraldas.<br/><br/>
                Su restaurante es un verdadero tesoro para los amantes de la comida tradicional ecuatoriana, especialmente aquellos que buscan deleitarse con los ricos y variados platos de la costa norte del país.<br/><br/>
                El restaurante del Hotel Torre Eiffel Atacames es el lugar perfecto para disfrutar de una experiencia culinaria única. Además de su deliciosa comida, el ambiente acogedor y el servicio amable harán que te sientas como en casa. Si estás buscando un lugar para probar la auténtica gastronomía esmeraldeña, no dudes en visitar este restaurante.
                </p>
            </div>
        </div>
    </section>
  )
}

export default SectionCacao